var map = {
	"./characters/Characters_1.png": [
		86690,
		6690
	],
	"./characters/Characters_117.png": [
		99372,
		9372
	],
	"./characters/Characters_119.png": [
		79433,
		9433
	],
	"./characters/Characters_16.png": [
		16881,
		6881
	],
	"./characters/Characters_17.png": [
		95622,
		5622
	],
	"./characters/Characters_176.png": [
		82512,
		1062
	],
	"./characters/Characters_177.png": [
		21314,
		1314
	],
	"./characters/Characters_18.png": [
		31045,
		1045
	],
	"./characters/Characters_19.png": [
		49697,
		9697
	],
	"./characters/Characters_20.png": [
		29858,
		9858
	],
	"./characters/Characters_21.png": [
		2755,
		2755
	],
	"./characters/Characters_22.png": [
		61754,
		1754
	],
	"./characters/Characters_23.png": [
		54052,
		4052
	],
	"./characters/Characters_24.png": [
		70456,
		456
	],
	"./characters/Characters_25.png": [
		14176,
		4176
	],
	"./characters/Characters_26.png": [
		43035,
		3035
	],
	"./characters/Characters_27.png": [
		77458,
		7458
	],
	"./characters/Characters_28.png": [
		54472,
		4472
	],
	"./characters/Characters_29.png": [
		87948,
		7948
	],
	"./characters/Characters_3.png": [
		83891,
		3891
	],
	"./characters/Characters_30.png": [
		64565,
		4565
	],
	"./characters/Characters_31.png": [
		39943,
		9943
	],
	"./characters/Characters_32.png": [
		81247,
		1247
	],
	"./characters/Characters_33.png": [
		27527,
		7527
	],
	"./characters/Characters_34.png": [
		30783,
		783
	],
	"./characters/Characters_35.png": [
		70004,
		4
	],
	"./characters/Characters_36.png": [
		92318,
		2318
	],
	"./characters/Characters_37.png": [
		5141,
		5141
	],
	"./characters/Characters_38.png": [
		66582,
		6582
	],
	"./characters/Characters_39.png": [
		78520,
		9887
	],
	"./characters/Characters_40.png": [
		72417,
		2417
	],
	"./characters/Characters_41.png": [
		2730,
		2730
	],
	"./characters/Characters_42.png": [
		85956,
		5956
	],
	"./characters/Characters_43.png": [
		37099,
		7099
	],
	"./characters/Characters_44.png": [
		7529,
		7529
	],
	"./characters/Characters_45.png": [
		76855,
		6855
	],
	"./characters/Characters_46.png": [
		54730,
		4730
	],
	"./characters/Characters_47.png": [
		10697,
		697
	],
	"./characters/Characters_48.png": [
		60699,
		699
	],
	"./characters/Characters_49.png": [
		63581,
		3581
	],
	"./characters/Characters_50.png": [
		1739,
		1739
	],
	"./characters/Characters_51.png": [
		78658,
		8658
	],
	"./characters/Characters_52.png": [
		93069,
		3069
	],
	"./characters/Characters_53.png": [
		32262,
		2262
	],
	"./characters/Characters_54.png": [
		66143,
		6143
	],
	"./characters/Characters_55.png": [
		62498,
		2498
	],
	"./characters/Characters_56.png": [
		87470,
		7470
	],
	"./characters/Characters_57.png": [
		85608,
		5608
	],
	"./characters/Characters_58.png": [
		46691,
		6691
	],
	"./characters/Characters_59.png": [
		85052,
		5052
	],
	"./characters/Characters_60.png": [
		92707,
		2707
	],
	"./characters/Characters_61.png": [
		61472,
		1472
	],
	"./characters/Characters_62.png": [
		63132,
		3132
	],
	"./characters/Characters_63.png": [
		23816,
		3816
	],
	"./characters/Characters_64.png": [
		60141,
		141
	],
	"./characters/Characters_65.png": [
		5482,
		5482
	],
	"./characters/complete/ace-visconti.png": [
		24287,
		4287
	],
	"./characters/complete/adam-francis.png": [
		20792,
		792
	],
	"./characters/complete/ashley-j-williams.png": [
		99055,
		9055
	],
	"./characters/complete/cheryl-mason.png": [
		68622,
		8622
	],
	"./characters/complete/claudette-morel.png": [
		79905,
		9905
	],
	"./characters/complete/david-king.png": [
		1165,
		1165
	],
	"./characters/complete/detective-david-tapp.png": [
		49138,
		9138
	],
	"./characters/complete/dwight-fairfield.png": [
		5658,
		5658
	],
	"./characters/complete/elodie-rakoto.png": [
		91787,
		1787
	],
	"./characters/complete/felix-richter.png": [
		68643,
		8643
	],
	"./characters/complete/feng-min.png": [
		55373,
		5373
	],
	"./characters/complete/haddie-kaur.png": [
		6223,
		6223
	],
	"./characters/complete/jake-park.png": [
		50128,
		128
	],
	"./characters/complete/jane-romero.png": [
		79715,
		9715
	],
	"./characters/complete/jeffrey-jeff-johansen.png": [
		46061,
		6061
	],
	"./characters/complete/jill-valentine.png": [
		75258,
		5258
	],
	"./characters/complete/jonah-vasquez.png": [
		85700,
		5700
	],
	"./characters/complete/kate-denson.png": [
		75313,
		5313
	],
	"./characters/complete/laurie-strode.png": [
		89784,
		9784
	],
	"./characters/complete/leon-s-kennedy.png": [
		95742,
		5742
	],
	"./characters/complete/meg-thomas.png": [
		57310,
		7310
	],
	"./characters/complete/mikaela-reid.png": [
		19215,
		9215
	],
	"./characters/complete/nancy-wheeler.png": [
		99379,
		9379
	],
	"./characters/complete/nea-karlsson.png": [
		14214,
		4214
	],
	"./characters/complete/quentin-smith.png": [
		1046,
		1046
	],
	"./characters/complete/steve-harrington.png": [
		59478,
		9478
	],
	"./characters/complete/the-artist.png": [
		28401,
		8401
	],
	"./characters/complete/the-blight.png": [
		42064,
		2064
	],
	"./characters/complete/the-cannibal.png": [
		50384,
		384
	],
	"./characters/complete/the-cenobite.png": [
		79021,
		9021
	],
	"./characters/complete/the-clown.png": [
		68551,
		8551
	],
	"./characters/complete/the-deathslinger.png": [
		57803,
		7803
	],
	"./characters/complete/the-demogorgon.png": [
		66065,
		6065
	],
	"./characters/complete/the-doctor.png": [
		79266,
		9266
	],
	"./characters/complete/the-dredge.png": [
		44456,
		4456
	],
	"./characters/complete/the-drege.jpeg": [
		71816,
		1816
	],
	"./characters/complete/the-drege.png": [
		7038,
		7038
	],
	"./characters/complete/the-excecutioner.png": [
		6372,
		6372
	],
	"./characters/complete/the-executioner.png": [
		6824,
		6824
	],
	"./characters/complete/the-ghost-face.png": [
		37455,
		7455
	],
	"./characters/complete/the-hag.png": [
		90821,
		821
	],
	"./characters/complete/the-hillbilly.png": [
		56628,
		6628
	],
	"./characters/complete/the-huntress.png": [
		25167,
		5167
	],
	"./characters/complete/the-legion.png": [
		76668,
		6668
	],
	"./characters/complete/the-nemesis.png": [
		33152,
		3152
	],
	"./characters/complete/the-nightmare.png": [
		36944,
		6944
	],
	"./characters/complete/the-nurse.png": [
		87449,
		7449
	],
	"./characters/complete/the-oni.png": [
		65843,
		5843
	],
	"./characters/complete/the-onryo.png": [
		64314,
		4314
	],
	"./characters/complete/the-pig.png": [
		82153,
		2153
	],
	"./characters/complete/the-plague.png": [
		73364,
		3364
	],
	"./characters/complete/the-shape.png": [
		66091,
		6091
	],
	"./characters/complete/the-spirit.png": [
		34847,
		4847
	],
	"./characters/complete/the-trapper.png": [
		67128,
		7128
	],
	"./characters/complete/the-trickster.png": [
		29994,
		9994
	],
	"./characters/complete/the-twins.png": [
		82782,
		2782
	],
	"./characters/complete/the-wraith.png": [
		75252,
		5252
	],
	"./characters/complete/william-bill-overbeck.png": [
		52306,
		2306
	],
	"./characters/complete/yoichi-asakawa.png": [
		13939,
		3939
	],
	"./characters/complete/yui-kimura.png": [
		84891,
		4891
	],
	"./characters/complete/yun-jin-lee.png": [
		65647,
		5647
	],
	"./characters/complete/zarina-kassir.png": [
		13535,
		3535
	],
	"./perks/100.png": [
		28244,
		8244
	],
	"./perks/101.png": [
		76291,
		6291
	],
	"./perks/102.png": [
		41813,
		1813
	],
	"./perks/103.png": [
		18322,
		8322
	],
	"./perks/104.png": [
		89004,
		9004
	],
	"./perks/105.png": [
		55401,
		5401
	],
	"./perks/106.png": [
		95480,
		5480
	],
	"./perks/107.png": [
		8705,
		8705
	],
	"./perks/108.png": [
		51060,
		1060
	],
	"./perks/109.png": [
		36070,
		6070
	],
	"./perks/110.png": [
		21237,
		1237
	],
	"./perks/111.png": [
		11836,
		1836
	],
	"./perks/112.png": [
		34116,
		4116
	],
	"./perks/113.png": [
		24793,
		4793
	],
	"./perks/114.png": [
		78834,
		8834
	],
	"./perks/115.png": [
		59986,
		9986
	],
	"./perks/116.png": [
		67088,
		7088
	],
	"./perks/117.png": [
		2120,
		2120
	],
	"./perks/118.png": [
		40552,
		552
	],
	"./perks/119.png": [
		65575,
		5575
	],
	"./perks/120.png": [
		48181,
		8181
	],
	"./perks/121.png": [
		98908,
		8908
	],
	"./perks/122.png": [
		81047,
		1047
	],
	"./perks/123.png": [
		82890,
		2890
	],
	"./perks/124.png": [
		48062,
		8062
	],
	"./perks/125.png": [
		3997,
		3997
	],
	"./perks/126.png": [
		11321,
		1321
	],
	"./perks/127.png": [
		29543,
		9543
	],
	"./perks/128.png": [
		66020,
		6020
	],
	"./perks/129.png": [
		86668,
		1808
	],
	"./perks/130.png": [
		40656,
		656
	],
	"./perks/131.png": [
		54670,
		4670
	],
	"./perks/132.png": [
		55760,
		5760
	],
	"./perks/133.png": [
		14220,
		4220
	],
	"./perks/134.png": [
		81032,
		1032
	],
	"./perks/135.png": [
		68435,
		8435
	],
	"./perks/136.png": [
		47322,
		7322
	],
	"./perks/137.png": [
		68360,
		8360
	],
	"./perks/138.png": [
		60174,
		174
	],
	"./perks/139.png": [
		84217,
		4217
	],
	"./perks/140.png": [
		92483,
		2483
	],
	"./perks/141.png": [
		98681,
		8681
	],
	"./perks/142.png": [
		45330,
		5330
	],
	"./perks/143.png": [
		21660,
		1660
	],
	"./perks/144.png": [
		5097,
		5097
	],
	"./perks/145.png": [
		31812,
		1812
	],
	"./perks/146.png": [
		67875,
		7875
	],
	"./perks/147.png": [
		15035,
		5035
	],
	"./perks/148.png": [
		17916,
		7916
	],
	"./perks/149.png": [
		98987,
		8987
	],
	"./perks/150.png": [
		44599,
		4599
	],
	"./perks/151.png": [
		325,
		325
	],
	"./perks/152.png": [
		49060,
		9060
	],
	"./perks/153.png": [
		35181,
		5181
	],
	"./perks/154.png": [
		92251,
		2251
	],
	"./perks/155.png": [
		23028,
		3028
	],
	"./perks/156.png": [
		34844,
		4844
	],
	"./perks/157.png": [
		63444,
		3444
	],
	"./perks/158.png": [
		91492,
		1492
	],
	"./perks/159.png": [
		98912,
		8912
	],
	"./perks/16.png": [
		29668,
		9668
	],
	"./perks/160.png": [
		51345,
		1345
	],
	"./perks/161.png": [
		24567,
		4567
	],
	"./perks/162.png": [
		58474,
		8474
	],
	"./perks/163.png": [
		61244,
		1244
	],
	"./perks/164.png": [
		57263,
		7263
	],
	"./perks/165.png": [
		69184,
		9184
	],
	"./perks/166.png": [
		24701,
		4701
	],
	"./perks/167.png": [
		14686,
		4686
	],
	"./perks/168.png": [
		77179,
		7179
	],
	"./perks/169.png": [
		81220,
		1220
	],
	"./perks/17.png": [
		68569,
		8569
	],
	"./perks/170.png": [
		39846,
		9846
	],
	"./perks/171.png": [
		86791,
		6791
	],
	"./perks/172.png": [
		20119,
		119
	],
	"./perks/173.png": [
		78197,
		8197
	],
	"./perks/174.png": [
		78868,
		8868
	],
	"./perks/175.png": [
		43409,
		3409
	],
	"./perks/176.png": [
		55237,
		5237
	],
	"./perks/177.png": [
		97236,
		7236
	],
	"./perks/178.png": [
		92438,
		2438
	],
	"./perks/179.png": [
		28418,
		8418
	],
	"./perks/18.png": [
		12113,
		2113
	],
	"./perks/180.png": [
		44080,
		4080
	],
	"./perks/181.png": [
		22994,
		2994
	],
	"./perks/182.png": [
		68108,
		8108
	],
	"./perks/183.png": [
		1088,
		1088
	],
	"./perks/184.png": [
		91072,
		1072
	],
	"./perks/185.png": [
		28644,
		8644
	],
	"./perks/186.png": [
		25609,
		5609
	],
	"./perks/187.png": [
		72191,
		2191
	],
	"./perks/188.png": [
		44129,
		4129
	],
	"./perks/189.png": [
		18450,
		8450
	],
	"./perks/19.png": [
		64294,
		4294
	],
	"./perks/190.png": [
		72265,
		2265
	],
	"./perks/191.png": [
		33529,
		3529
	],
	"./perks/192.png": [
		59703,
		9703
	],
	"./perks/193.png": [
		8672,
		8672
	],
	"./perks/194.png": [
		88065,
		8065
	],
	"./perks/195.png": [
		80257,
		257
	],
	"./perks/196.png": [
		25073,
		5073
	],
	"./perks/197.png": [
		92994,
		9689
	],
	"./perks/198.png": [
		28157,
		8157
	],
	"./perks/199.png": [
		89543,
		5452
	],
	"./perks/200.png": [
		17914,
		7914
	],
	"./perks/201.png": [
		61859,
		1859
	],
	"./perks/202.png": [
		93920,
		3920
	],
	"./perks/203.png": [
		26379,
		6379
	],
	"./perks/204.png": [
		16167,
		6167
	],
	"./perks/205.png": [
		29828,
		9828
	],
	"./perks/206.png": [
		12906,
		2906
	],
	"./perks/207.png": [
		57513,
		7513
	],
	"./perks/28.png": [
		10982,
		982
	],
	"./perks/29.png": [
		16737,
		6737
	],
	"./perks/30.png": [
		16039,
		6039
	],
	"./perks/31.png": [
		18534,
		8534
	],
	"./perks/32.png": [
		19143,
		9143
	],
	"./perks/33.png": [
		17289,
		7289
	],
	"./perks/34.png": [
		71440,
		1440
	],
	"./perks/35.png": [
		37106,
		7106
	],
	"./perks/36.png": [
		21955,
		1955
	],
	"./perks/37.png": [
		29407,
		9407
	],
	"./perks/38.png": [
		54724,
		4724
	],
	"./perks/39.png": [
		57768,
		7768
	],
	"./perks/391.png": [
		5711,
		5711
	],
	"./perks/392.png": [
		43477,
		3477
	],
	"./perks/393.png": [
		60554,
		554
	],
	"./perks/394.png": [
		35633,
		2844
	],
	"./perks/399.png": [
		8237,
		8237
	],
	"./perks/40.png": [
		58910,
		8910
	],
	"./perks/400.png": [
		34090,
		4090
	],
	"./perks/401.png": [
		36978,
		6978
	],
	"./perks/41.png": [
		81503,
		1503
	],
	"./perks/42.png": [
		74980,
		4980
	],
	"./perks/44.png": [
		66581,
		6581
	],
	"./perks/45.png": [
		62585,
		2585
	],
	"./perks/46.png": [
		87325,
		7325
	],
	"./perks/47.png": [
		59045,
		9045
	],
	"./perks/48.png": [
		14623,
		4623
	],
	"./perks/51.png": [
		44421,
		4421
	],
	"./perks/52.png": [
		61966,
		1966
	],
	"./perks/53.png": [
		66443,
		6443
	],
	"./perks/54.png": [
		30472,
		472
	],
	"./perks/55.png": [
		76309,
		6309
	],
	"./perks/56.png": [
		13625,
		3625
	],
	"./perks/57.png": [
		51356,
		1356
	],
	"./perks/58.png": [
		32347,
		2347
	],
	"./perks/59.png": [
		60443,
		443
	],
	"./perks/598.png": [
		25953,
		5953
	],
	"./perks/599.png": [
		44484,
		4484
	],
	"./perks/5f46d9afa3777022ec6260b3.png": [
		52120,
		3510
	],
	"./perks/5f46d9afa3777022ec6260b4.png": [
		28774,
		8774
	],
	"./perks/5f46d9afa3777022ec6260b5.png": [
		51591,
		1591
	],
	"./perks/5f46d9afa3777022ec6260b6.png": [
		98141,
		8141
	],
	"./perks/5f46d9afa3777022ec6260b7.png": [
		14532,
		4532
	],
	"./perks/5f46d9afa3777022ec6260b8.png": [
		45906,
		5906
	],
	"./perks/5f46d9afa3777022ec6260b9.png": [
		56473,
		6473
	],
	"./perks/5f46d9afa3777022ec6260ba.png": [
		78299,
		8299
	],
	"./perks/5f46d9afa3777022ec6260bb.png": [
		65237,
		9575
	],
	"./perks/5f46d9afa3777022ec6260bc.png": [
		15317,
		5317
	],
	"./perks/5f46d9afa3777022ec6260bd.png": [
		14654,
		4654
	],
	"./perks/5f46d9afa3777022ec6260be.png": [
		31490,
		1490
	],
	"./perks/5f46d9afa3777022ec6260bf.png": [
		57409,
		7409
	],
	"./perks/5f46d9afa3777022ec6260c0.png": [
		77528,
		7528
	],
	"./perks/5f46d9afa3777022ec6260f7.png": [
		36846,
		6846
	],
	"./perks/5f46d9afa3777022ec6260f8.png": [
		25969,
		5969
	],
	"./perks/5f46d9afa3777022ec6260f9.png": [
		87662,
		7662
	],
	"./perks/5f46d9afa3777022ec6260fa.png": [
		14825,
		4825
	],
	"./perks/5f46d9afa3777022ec6260fb.png": [
		93734,
		3734
	],
	"./perks/5f46d9afa3777022ec6260fc.png": [
		366,
		366
	],
	"./perks/5f46d9afa3777022ec6260fd.png": [
		1672,
		1672
	],
	"./perks/5f46d9afa3777022ec6260fe.png": [
		81508,
		1508
	],
	"./perks/5f46d9afa3777022ec6260ff.png": [
		4462,
		4462
	],
	"./perks/5f46d9afa3777022ec626100.png": [
		42257,
		2257
	],
	"./perks/5f46d9afa3777022ec626101.png": [
		46816,
		6816
	],
	"./perks/5f46d9afa3777022ec626102.png": [
		6832,
		6832
	],
	"./perks/5f46d9afa3777022ec626151.png": [
		68361,
		8361
	],
	"./perks/5f46d9afa3777022ec626152.png": [
		70139,
		139
	],
	"./perks/5f46d9afa3777022ec626153.png": [
		40236,
		236
	],
	"./perks/5f46d9afa3777022ec626154.png": [
		89113,
		9113
	],
	"./perks/5f46d9afa3777022ec626155.png": [
		98342,
		8342
	],
	"./perks/5f46d9afa3777022ec626156.png": [
		17058,
		7058
	],
	"./perks/5f46d9afa3777022ec626157.png": [
		55103,
		5103
	],
	"./perks/5f46d9afa3777022ec626158.png": [
		73515,
		3515
	],
	"./perks/5f46d9afa3777022ec626159.png": [
		15533,
		5533
	],
	"./perks/5f46d9afa3777022ec62615a.png": [
		16370,
		6370
	],
	"./perks/5f46d9afa3777022ec62615b.png": [
		72792,
		2792
	],
	"./perks/5f46d9afa3777022ec62615c.png": [
		10009,
		9
	],
	"./perks/5f46d9afa3777022ec62615d.png": [
		95423,
		5423
	],
	"./perks/5f46d9afa3777022ec62615e.png": [
		28996,
		8996
	],
	"./perks/5f46d9afa3777022ec626195.png": [
		62331,
		2331
	],
	"./perks/5f46d9afa3777022ec626196.png": [
		66842,
		6842
	],
	"./perks/5f46d9afa3777022ec626197.png": [
		48223,
		8223
	],
	"./perks/5f46d9afa3777022ec626198.png": [
		13562,
		3562
	],
	"./perks/5f46d9afa3777022ec626199.png": [
		24132,
		4132
	],
	"./perks/5f46d9afa3777022ec62619a.png": [
		50559,
		559
	],
	"./perks/5f46d9afa3777022ec62619b.png": [
		35353,
		5353
	],
	"./perks/5f46d9afa3777022ec62619c.png": [
		76082,
		6082
	],
	"./perks/5f46d9afa3777022ec62619d.png": [
		88529,
		8529
	],
	"./perks/5f46d9afa3777022ec62619e.png": [
		3834,
		3834
	],
	"./perks/5f46d9afa3777022ec62619f.png": [
		26417,
		6417
	],
	"./perks/5f46d9afa3777022ec6261a0.png": [
		5146,
		5146
	],
	"./perks/60.png": [
		85348,
		5348
	],
	"./perks/600.png": [
		57586,
		7586
	],
	"./perks/601.png": [
		30849,
		849
	],
	"./perks/602.png": [
		35584,
		5584
	],
	"./perks/603.png": [
		2512,
		2512
	],
	"./perks/604.png": [
		66014,
		6014
	],
	"./perks/61.png": [
		65488,
		5488
	],
	"./perks/62.png": [
		74197,
		4197
	],
	"./perks/63.png": [
		92275,
		2275
	],
	"./perks/64.png": [
		15959,
		5959
	],
	"./perks/65.png": [
		60830,
		830
	],
	"./perks/66.png": [
		49509,
		9509
	],
	"./perks/67.png": [
		331,
		331
	],
	"./perks/68.png": [
		91927,
		1927
	],
	"./perks/69.png": [
		45240,
		5240
	],
	"./perks/70.png": [
		71058,
		1058
	],
	"./perks/71.png": [
		38227,
		8227
	],
	"./perks/72.png": [
		33185,
		3185
	],
	"./perks/73.png": [
		22479,
		2479
	],
	"./perks/74.png": [
		1627,
		1627
	],
	"./perks/75.png": [
		87787,
		7787
	],
	"./perks/76.png": [
		72494,
		2494
	],
	"./perks/77.png": [
		92459,
		2459
	],
	"./perks/78.png": [
		16090,
		6090
	],
	"./perks/79.png": [
		90080,
		80
	],
	"./perks/80.png": [
		88620,
		8620
	],
	"./perks/81.png": [
		88152,
		8152
	],
	"./perks/82.png": [
		40828,
		828
	],
	"./perks/83.png": [
		83241,
		3241
	],
	"./perks/84.png": [
		92557,
		2557
	],
	"./perks/85.png": [
		27857,
		7857
	],
	"./perks/86.png": [
		38239,
		8239
	],
	"./perks/87.png": [
		52710,
		2710
	],
	"./perks/88.png": [
		424,
		424
	],
	"./perks/89.png": [
		7113,
		7113
	],
	"./perks/90.png": [
		66348,
		6348
	],
	"./perks/91.png": [
		98135,
		8135
	],
	"./perks/92.png": [
		48459,
		8459
	],
	"./perks/93.png": [
		6975,
		6975
	],
	"./perks/94.png": [
		55853,
		5853
	],
	"./perks/95.png": [
		7451,
		7451
	],
	"./perks/96.png": [
		96047,
		6047
	],
	"./perks/97.png": [
		2019,
		2019
	],
	"./perks/98.png": [
		83,
		83
	],
	"./perks/99.png": [
		34072,
		4072
	],
	"./perks/slot1.png": [
		43013,
		3013
	],
	"./utils/background.svg": [
		62350,
		2350
	],
	"./utils/big_perks.svg": [
		17045,
		7045
	],
	"./utils/black-circle.svg": [
		41211,
		1211
	],
	"./utils/circle_perks.svg": [
		78244,
		3558
	],
	"./utils/facebook_logo.png": [
		20316,
		316
	],
	"./utils/google_logo.png": [
		74790,
		4790
	],
	"./utils/icon.png": [
		23872,
		3872
	],
	"./utils/iconProfile.png": [
		86418,
		6418
	],
	"./utils/iconProfile.svg": [
		5633,
		5633
	],
	"./utils/killer_logo.svg": [
		34126,
		4126
	],
	"./utils/login/build1.png": [
		83873,
		3873
	],
	"./utils/login/cazadora.png": [
		49611,
		9611
	],
	"./utils/login/rectangulo.png": [
		17650,
		7650
	],
	"./utils/logo.png": [
		83622,
		3622
	],
	"./utils/logo.svg": [
		67841,
		7841
	],
	"./utils/slot.png": [
		69867,
		9867
	],
	"./utils/slot1.png": [
		82938,
		2938
	],
	"./utils/small-circle.svg": [
		73013,
		6075
	],
	"./utils/small_perks.svg": [
		78281,
		8281
	],
	"./utils/sponsors/epic.png": [
		19108,
		9108
	],
	"./utils/sponsors/epic.svg": [
		1439,
		1439
	],
	"./utils/sponsors/microsoft.png": [
		17155,
		7155
	],
	"./utils/sponsors/microsoft.svg": [
		69985,
		9985
	],
	"./utils/sponsors/nintendo.png": [
		88724,
		8724
	],
	"./utils/sponsors/nintendo.svg": [
		75383,
		5383
	],
	"./utils/sponsors/playstation.png": [
		28295,
		8295
	],
	"./utils/sponsors/playstation.svg": [
		3619,
		3619
	],
	"./utils/sponsors/stadia.png": [
		22408,
		2408
	],
	"./utils/sponsors/stadia.svg": [
		19724,
		9724
	],
	"./utils/sponsors/steam.png": [
		81878,
		1878
	],
	"./utils/sponsors/steam.svg": [
		27799,
		7799
	],
	"./utils/sponsors/xbox.png": [
		19052,
		9052
	],
	"./utils/sponsors/xbox.svg": [
		83890,
		3890
	],
	"./utils/survivor_logo.svg": [
		82387,
		2387
	],
	"./utils/twitch_logo.png": [
		48520,
		8520
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 50585;
module.exports = webpackAsyncContext;